import moment from 'moment';
import React, { useEffect, useRef, useState } from 'react';
import Ticket from './Ticket';
import { fetchTicketList } from '../../actions/tickets-action';
import { useDispatch, useSelector } from 'react-redux';
import Loader from './Loader';
import { getCookie } from '../../utility/cookieProvider';
import { COOKIE, DATE_FORMATS, VERTICALS } from '../../constants/app-constant';
import { AddIcon, CloseIcon, DateIcon, FilterIcon, MenuIcon, ProfileFilledIcon, ProfileIcon, RemoveIcon, TimeIcon } from '../Icons/icons.component';
import NoDataMessage from './NoDataMessage';
import DateRangePicker from "rsuite/DateRangePicker";
// import "rsuite/dist/styles/rsuite-default.css";
import 'rsuite/DateRangePicker/styles/index.less';
import { getClientSubUserData } from '../../actions/client-action';
import ConceptLogo from "../../assets/images/conceptbiu-logo.png";
// import 'rsuite/dist/rsuite.min.css';

const TicketList = ({
  ticketLists,
  currentPage,
  setCurrentPage,
  totalPage,
  userList,
  isDataLoading,
  pagination={},
  mediaType,
  setMediaType,
  status,
  setStatus,
  setDateValue,
  setSubUserValue,
  monthCount,
  setcategory,
  category
}) => {
  const dispatch = useDispatch()
  const datePickerRef = useRef();
  const masterUser =
      useSelector(
        (state) => state.clientReducer && state.clientReducer.masterUser
      ) || {};
  const clientData =
    useSelector(
      (state) => state.clientReducer && state.clientReducer
    ) || {};
  const selectedClient =
    useSelector(
      (state) => state.clientReducer && state.clientReducer.selectedClient
    ) || {};
  const userId = getCookie(COOKIE.CONCEPT_USER_ID);
  const [list,setList] = useState([

  ])
  const [medialist,setMediaList] = useState([
    {value:VERTICALS.V_PRINT_AND_ONLINE_OLD,label:"All",top:'-50%',pRight:"91%",iRight:"82%",pColor:"rgb(0, 191, 255)",iColor:"orange"},
    {value:VERTICALS.V_PRINT_AND_ONLINE,label:"Print & Online",top:'-50%',pRight:"71%",iRight:"47%",pColor:"rgb(0, 191, 255)",iColor:"orange"},
    {value:VERTICALS.V_SOCIAL,label:"Social",top:'-50%',pRight:"35%",iRight:"22%",pColor:"rgb(0, 191, 255)",iColor:"orange"},
    {value:VERTICALS.V_TV,label:"TV",top:'-50%',pRight:"11%",iRight:"2%",pColor:"rgb(0, 191, 255)",iColor:"orange"},
  ])
  const [showList,setShowList] = useState(true)
  // const [selectedMedia,setSelectedMedia] = useState(0)
  const [isMsgLoading,setIsMsgLoading] = useState(true)
  const [tObj,setTObj] = useState({})
  const [messageData,setMessageData] = useState([])
  const [msgUserList,setMsgUserList] = useState([])
  const [showFilter,setShowFilter] = useState(false)
  const [subUserId,setSubUserId] = useState()
  const [isStartDate,setisStartDate] = useState(false)
  const [dateRangeValue,setdateRangeValue] = useState(null)
  const [firstDate,setfirstDate] = useState(null)
  const [isSelected,setIsSelected] = useState()
  const [tStatus,setTStatus] = useState(["0","1","2"])
   const [cat,setcat] = useState()
  useEffect(() => {
     console.log("API call useEffect triggered ticket list");
    setList(ticketLists)
  },[ticketLists])

  useEffect(() => {
    if(!clientData.subUserStatus && selectedClient && Object.keys(selectedClient).length && Object.keys(masterUser).length){
      dispatch(getClientSubUserData({client_id:selectedClient.id,isFilter:true,master_id: Number(masterUser.id)}));
    }
  },[clientData.subUserStatus,selectedClient,masterUser])

  const isSelectedFilter = (value) => {
    setMediaType(value)
  }

  const handlePrev = () => {
    setCurrentPage(currentPage-1)
  }

  const handleNext = () => {
    setCurrentPage(currentPage+1)
  }

  const handleTicketSelection = async (ticketData) => {
    setIsMsgLoading(true)
    setShowList(false)
    console.log("function is called ")
    let tObj = {
      user_type : 1,
      user_id : ticketData.user_id,
      // perPage : 50,
      // page : currentPage,
      client_id : selectedClient.id,
      header_id : ticketData.header_id
    }
    let tData = await fetchTicketList(tObj)
    if(Object.keys(tData).length){
      setMessageData(tData.data.data)
      setMsgUserList(tData.data.userDetails)
    }
    setTObj(ticketData)
    setIsMsgLoading(false)
  }

  const handleDateSelect = (d) => {
    if (isStartDate) {
      setfirstDate(moment(d).format("yyyy/MM/DD"))
    }
    if (firstDate != null && moment(firstDate).isBefore(moment(d))) {
      setdateRangeValue([new Date(firstDate),new Date(moment(d).format("yyyy/MM/DD"))])
      datePickerRef.current.close();
    }
    else if(firstDate != null){
      setdateRangeValue([new Date(moment(d).format("yyyy/MM/DD")),new Date(firstDate)])
      datePickerRef.current.close();
    }
  }

  const handleClean = () => {
    setisStartDate(true)
    setdateRangeValue(null)
  }

  const handleResetAll = () => {
    setdateRangeValue(null)
    setTStatus(["0","1","2"])
  }

  const handleApplyFilter = () => {
    setStatus(tStatus)
    setDateValue(dateRangeValue)
    setShowFilter(false)
    setSubUserValue(subUserId)
    setcategory(cat)
  }

  const handleStatus = (e) => {
    console.log(e)
    let tmpStatus = [...tStatus]
    if(e.target.checked){
      tmpStatus.push(e.target.value)
      setTStatus(tmpStatus)
    }
    else{
      setTStatus(tmpStatus.filter((tData) => tData != e.target.value))
    }
  }
  
  return (
    <>
      {showList?
        <>
          <div class="article-header">
            <div class="d-flex customWrap">
              <div className="dashboardMobileMenu">
                <button className="btn menuBtn" id="menuBtn">
                  <MenuIcon />
                </button>
                <img src={ConceptLogo} width="32" height="32" />
              </div>
              <div class="dhLeft d-flex dashboardHeaderTop">
                <div class="dhLeftWrap d-flex align-items-center">
                  <h1>Article Tracking</h1>
                </div>
              </div>
            </div>
            <div className='topFilterWrap'>
              <div className="mobTopHeading">
                <h1>Article Tracking</h1>
              </div>
              <div className='titleRow'>
                <div className='titleLeftWrap'>
                  <div className='filterWrap'>
                    <div role="group" className="rs-btn-group btn-group" style={{margin:"0 0 16px"}}>
                      {medialist.map((labelData) => (
                        <>
                          {Object.keys(pagination).length?
                            <>
                              {
                                (labelData.value == VERTICALS.V_PRINT_AND_ONLINE_OLD && pagination.aPCount != 0) || 
                                (labelData.value == VERTICALS.V_SOCIAL && pagination.aSPCount != 0) || 
                                (labelData.value == VERTICALS.V_PRINT_AND_ONLINE && pagination.aPOPCount != 0) || 
                                (labelData.value == VERTICALS.V_TV && pagination.aTVPCount != 0)?
                                <div
                                  className='number-bubble'
                                  style={{
                                    position: 'absolute',
                                    top: labelData.top,
                                    right: labelData.pRight,
                                    backgroundColor: labelData.pColor,
                                  }}
                                >
                                  {labelData.value == VERTICALS.V_PRINT_AND_ONLINE_OLD?
                                    pagination.aPCount
                                    :(
                                      labelData.value == VERTICALS.V_SOCIAL?
                                        pagination.aSPCount
                                        :(
                                          labelData.value == VERTICALS.V_PRINT_AND_ONLINE?
                                            pagination.aPOPCount
                                            :(
                                              labelData.value == VERTICALS.V_TV?
                                                pagination.aTVPCount
                                                :0
                                            )
                                        )
                                    )}
                                </div>
                                :""}

                              {(labelData.value == VERTICALS.V_PRINT_AND_ONLINE_OLD && pagination.aICount != 0) || 
                                (labelData.value == VERTICALS.V_SOCIAL && pagination.aSICount != 0) || 
                                (labelData.value == VERTICALS.V_PRINT_AND_ONLINE && pagination.aPOICount != 0) || 
                                (labelData.value == VERTICALS.V_TV && pagination.aTVICount != 0)?
                                <div
                                  className='number-bubble'
                                  style={{
                                    position: 'absolute',
                                    top: labelData.top,
                                    right: labelData.iRight,
                                    backgroundColor: labelData.iColor,
                                  }}
                                >
                                  {labelData.value == VERTICALS.V_PRINT_AND_ONLINE_OLD?
                                    pagination.aICount
                                    :(
                                      labelData.value == VERTICALS.V_SOCIAL?
                                        pagination.aSICount
                                        :(
                                          labelData.value == VERTICALS.V_PRINT_AND_ONLINE?
                                            pagination.aPOICount
                                            :(
                                              labelData.value == VERTICALS.V_TV?
                                                pagination.aTVICount
                                                :0
                                            )
                                        )
                                    )}
                                </div>
                                :""}
                            </>
                          :""}
                          <button
                            onClick={() => {isSelectedFilter(labelData.value)}}
                            type="button"
                            className={`btn btn-primary ${
                              mediaType === labelData.value ? "active" : ""+labelData.value
                            }`}
                          >
                            {labelData.label}
                          </button>
                        </>
                      ))}
                    </div>
                    <label className="count-label">Total Monthly Count : {Object.keys(monthCount)?monthCount.aCount:"0"} ,New : {Object.keys(monthCount)?monthCount.aPCount:"0"} ,In Progress : {Object.keys(monthCount)?monthCount.aICount:"0"} ,Completed : {Object.keys(monthCount)?monthCount.aCCount:"0"}</label>
                    <button
                      onClick={() => setShowFilter(true)}
                      className="btn filterBtn"
                    >
                      <FilterIcon />
                    </button>
                  </div>
                </div>
                <div className="rightBtnContainer">
                  <ul className="dropDownContainer">
                  <label className="count-label">Total Monthly Count : {Object.keys(monthCount)?monthCount.aCount:"0"} ,New : {Object.keys(monthCount)?monthCount.aPCount:"0"} ,In Progress : {Object.keys(monthCount)?monthCount.aICount:"0"} ,Completed : {Object.keys(monthCount)?monthCount.aCCount:"0"}</label>
                    <button
                      onClick={() => setShowFilter(true)}
                      className="btn filterBtn"
                    >
                      <FilterIcon /> <span>Filters</span>
                    </button>
                  </ul>
                  <div
                    className={`filtersWrap sideFilterWrap ${
                      !showFilter ? "hide" : "show"
                    }`}
                  >
                    <div className="filtersColumnWrap">
                      <div className="filtersWrap socialFiltersWrap">
                        <div className="filtersHeader d-flex">
                          <h4>Filters</h4>
                          <button onClick={() => setShowFilter(false)} className="closeIconWrap">
                            <CloseIcon />
                          </button>
                        </div>
                        <div className="filterReset">
                          <button onClick={() => handleResetAll()} className="btn resetAllBtn">
                            Reset All
                          </button>
                        </div>
                        <div className="filtersColumnWrap">
                          <DateRangePicker
                            // oneTap
                            // showOneCalendar
                            ref={datePickerRef}
                            key={"filter-internal-1"}
                            placeholder="Select Date Range"
                            onEnter={() => {setisStartDate(true);setdateRangeValue(null)}}
                            onSelect={(d) => handleDateSelect(d)}
                            onChange={(e) => {console.log(e)}}
                            onClean={() => handleClean()}
                            ranges={[]}
                            format={DATE_FORMATS.ddMMYYYY_dash}
                            value={dateRangeValue}
                            // defaultCalendarValue={[firstDay, lastDay]}
                            placement={"bottomEnd"}
                            // {...optionalPropsv1}
                            // showOneCalendar={isMobile()}
                          />
                          <div class="form-group">
                            <div class="filterDiv accordionDropdown">
                              <div class="filterLabel" 
                              // onClick={() => {setIsSelected(!isSelected)}}
                              >
                                <span>Status</span>
                                    {/* {isSelected ? (
                                      <i className="icon">
                                        <RemoveIcon />
                                      </i>
                                    ) : (
                                      <i className="icon">
                                        <AddIcon />
                                      </i>
                                    )} */}
                              </div>
                              <ul name="Status" class="addFiltersDropDown MEDIA_TYPE Filter show ">
                                <li class="filterOption">
                                  <label class="inputWrap">New<input onClick={handleStatus} type="checkbox" checked={tStatus.includes("0")} value={0} /><span class="checkmark"></span></label>
                                </li>
                                <li class="filterOption"><label class="inputWrap">In Progress<input onClick={handleStatus} type="checkbox" checked={tStatus.includes("1")} value={1} /><span class="checkmark"></span></label></li>
                                <li class="filterOption"><label class="inputWrap">Completed<input onClick={handleStatus} type="checkbox" checked={tStatus.includes("2")} value={2} /><span class="checkmark"></span></label></li>
                              </ul>
                            </div>
                              <div class="filterDiv filteInputText">
                                <label>Sub User</label>
                                <select class="form-control" onChange={(e) => {setSubUserId(e.target.value)}}>
                                    <option disabled="" class="reset-text" value="">Select Sub User</option>
                                    {clientData.subUserFilterData.map((userData) => (
                                      <option class="filterOption" value={userData.userId}>{userData.name}</option>
                                    ))}
                                </select>
                              </div>
                             <div class="filterDiv filteInputText">
                                <label>Category</label>
                                <select class="form-control" 
                                onChange={(e) => {console.log(e.target.value);setcat(e.target.value)}}
                                  >
                                    <option disabled="" class="reset-text" value="reset">Select category</option>
                                    <option class="filterOption" value={1}>Insurance Companies</option>
                                    <option class="filterOption" value={2}>State</option>
                                </select>
                              </div>
                            </div>
                          <div className="form-group form-action text-right">
                            <button className="btn btnBlue" onClick={handleApplyFilter}>
                              Apply
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {Object.keys(pagination).length?
            <div style={{color: "rgb(0, 54, 185)",marginTop: "5px",marginBottom: "5px",fontSize: "14px"}}>
              Totally <span class="feed-count-info">{list.length}</span> articles in All category
            </div>
          :""}
          <ul class="article-list">
            {list.map((lData) => (
              <li class="article-item" onClick={() => {handleTicketSelection(lData)}}>
                  <span class="status" style={{color:(lData.status === 0?"#ffffff":(lData.status === 1?"#ffffff":"#000000")),backgroundColor:(lData.status === 0?"#00bfff":(lData.status === 1?"orange":"green"))}}>
                    <label>{lData.status === 0?"New":(lData.status === 1?"In Progress":"Completed")} </label> 
                  </span> #{lData.header_id}
                  <label className="author">
                    <label className='col-75'>
                      <h2>{lData.heading}</h2>
                      {lData.message}
                    </label>
                    <label className='col-25' style={{fontWeight:"bolder"}}><ProfileFilledIcon />{userList.find((uData) => uData.userId === lData.user_id)?.name}</label>
                  </label>
                  <hr style={{marginTop:'2px',marginBottom:'2px'}} />
                  <label className="author ">
                    <label class="date col-95"><TimeIcon />{moment(lData.created_date).format("hh:mm A")}</label>
                    <label class="date col-05"><DateIcon />{moment(lData.created_date).format("DD-MM-YYYY")}</label>
                  </label>
              </li>
            ))}
            {isDataLoading?<Loader />:(!list.length?
              <div className='text-center'>
                <NoDataMessage
                  text="No Article Tracking Detail Found"
                  subtext="Once Article Tracking Created It Will Reflect Here"
                />
              </div>:"")}
          </ul>
        </>
        :<Ticket 
          setShowList={setShowList}
          ticketData={tObj}
          messageData = {messageData}
          msgUserList = {msgUserList}
          isMsgLoading = {isMsgLoading}
        />
      }
    </>
  );
}

export default TicketList;
